import styled from 'styled-components';

export const ClaimSideWrapper = styled.div`
	width: 720px;
`;
